// extracted by mini-css-extract-plugin
export default {"sub_heading_wrapper":"SubHeading_sub_heading_wrapper__jJZnU"};